import messages from './messages/splashbackMessages';
import WallEdgeStrip from './images/splashbacks/PLAN_BackEdgeStrip.png';
import WallEdgeStripLarge from './images/splashbacks/PLAN_BackEdgeStrip_500x500.png';
import WallEdgeStripPictogram from './images/splashbacks/PLAN_BackEdgeStrip_Pictogram.png';

export const NONE = 'none';
export const WALL_PANEL_ID = 'wall-panel';
export const WALL_EDGING_STRIP_ID = 'wall-edging-strip';
export const WALL_EDGING_STRIP_CUSTOMIZABLE_ID = 'wall-edging-strip-customizable';

export function generateSplashbacks(businessRules, includeWallEdgingStrip, includeWallEdgingStripCustomizable) {
  const { wallPanelDefaultHeight, wallEdgingStripCustomizableDefaultHeight } = businessRules;
  const defaultHeight = wallPanelDefaultHeight || 550;
  const edgingStripCustomizableDefaultHeight = wallEdgingStripCustomizableDefaultHeight || 120;
  if (!wallPanelDefaultHeight) {
    // eslint-disable-next-line no-console
    console.error(`Setting wall panel default height to ${defaultHeight} due to wallPanelDefaultHeight not in rules`);
  }

  const splashbacks = [
    {
      id: NONE,
      displayName: messages.none,
    },
    {
      id: WALL_PANEL_ID,
      displayName: messages.wallPanel,
      defaultHeight,
    },
  ];

  if (includeWallEdgingStrip) {
    splashbacks.push(
      {
        id: WALL_EDGING_STRIP_ID,
        displayName: messages.wallEdgingStrip,
        displayImage: WallEdgeStrip,
        displayImageLarge: WallEdgeStripLarge,
        pictogram: WallEdgeStripPictogram,
        padImage: true,
      },
    );
  }

  if (includeWallEdgingStripCustomizable) {
    splashbacks.push(
      {
        id: WALL_EDGING_STRIP_CUSTOMIZABLE_ID,
        displayName: messages.wallEdgingStripCustomizable,
        displayImage: WallEdgeStrip,
        displayImageLarge: WallEdgeStripLarge,
        pictogram: WallEdgeStripPictogram,
        padImage: true,
        defaultHeight: edgingStripCustomizableDefaultHeight,
      },
    );
  }
  return splashbacks;
}

export function generateWallEdgingStrip(id, businessRules, items) {
  const material = businessRules.materials.find((m) => m.id === id);
  if(material.incompatibleWithWallEdgingStrip){
    console.log('Ignoring wall edging strip for material ', id, ' according to business rule.' )
  }
  if (material && material.wallEdgingStrip && !material.incompatibleWithWallEdgingStrip) {
    const { ItemNo: itemNo } = material.wallEdgingStrip;
    return items.find((i) => i.ItemNo === itemNo) || null;
  } else {
    return null;
  }
}

export function generateWallEdgingStripCustomizable(id, businessRules, items) {
  const material = businessRules.materials.find((m) => m.id === id);
  if(material.incompatibleWithWallEdgingStrip){
    console.log('Ignoring wall edging strip for material ', id, ' according to business rule.' )
  }
  if (material && material.wallEdgingStripCustomizable && !material.incompatibleWithWallEdgingStrip) {
    const { ItemNo: itemNo } = material.wallEdgingStripCustomizable;
    return items.find((i) => i.ItemNo === itemNo) || null;
  } else {
    return null;
  }
}
